import React from 'react';
import PropTypes from 'prop-types';
import styles from './AppLayout.module.css';
import AppSidebar from '../AppSidebar/AppSidebar';
import AppContent from '../AppContent/AppContent';

import { useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';

const AppLayout = () => {
  useEffect(() => {
    AOS.init({
      once: true
    });
  }, []);

  return (
    <div className={styles.AppLayout} data-testid="AppLayout">
      <div className='container-fluid'>
        <div className={styles.Wrapper+' row'}>
          <div className={styles.Sidebar+' col-lg-4 col-md-12'}>
            <div className={styles.SideBorder} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300"></div>
            <AppSidebar />
          </div>
          <div className={styles.Main+' col-lg-8 col-md-12'}>
            <AppContent />
          </div>
        </div>
      </div>
    </div>
  );
};

AppLayout.propTypes = {};

AppLayout.defaultProps = {};

export default AppLayout;
